import { render, staticRenderFns } from "./NormalDevice.vue?vue&type=template&id=a07b12dc&"
import script from "./NormalDevice.vue?vue&type=script&lang=ts&"
export * from "./NormalDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports